export enum RoutePath {
    CART = '/checkout/cart',
    PREVIEW = '/checkout/registration/preview',
    FOA_PREVIEW = '/checkout/registration/foa-preview',
    UPGRADE = '/checkout/registration/upgrade',
    DOWNGRADE = '/checkout/registration/downgrade',
    NO_CONTENT = '/_/no-content/regret',
    AUTH_OCC = '/checkout/auth/occ',
    CANNOT_RENEW = '/checkout/cannot-renew'
}
